import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import logo from "../../Assets/logo.png";
import imbl from "../../Assets/Logoimg.mp4";
import goldenBuildings from "../../Assets/golden_buildings.jpg";
import { useColorTheme } from "../../Context/ThemeContext/ThemeContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect } from "react";
import { LoginApi } from "../../Api/LoginApi/LoginApi";
import { SnackBarContext } from "../../Context/SnackBarContext/SnackBarContext";
import { useContext } from "react";
import { fetchUserRoles } from "../../Redux/Slice/Settings/UserSlice/UserSlice";
import { useDispatch } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import SignalRContext from "../../Context/SignalRContext/SignalRContext";
import { useSession } from "../../Context/SessionContext";
import { useSubscription } from "../../Context/SubscriptionContext";
import useFCM from "../../hooks/useFCM";
import { PaymentReminderModal } from "../../Components/PaymentReminderModel/PaymentReminderModel";
import { AdminSideBarData, GeneralSidebarData, SuperAdminSideBarData } from "../../Resources/SideBarData";
import { AdminRoutes, SuperAdminRoutes } from "../../AllRoutes/AllRoutes";

const useStyle = makeStyles(theme => {
  return {
    Container: {
      display: "flex",
      width: "100%",
      height: "100vh",
      justifyContent: "space-between",
      alignItems: "center",
      paddingLeft: "150px",
      [theme.breakpoints.down("md")]: {
        paddingLeft: "50px", //
      },
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "10px", //
      },
    },
    loginBox: {
      width: "100%",
      maxWidth: "450px",
      display: "flex",
      alignSelf: "center",
      flexDirection: "column",
      gap: "20px",
    },
    imgBox: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      alignItems: "center",
      padding: "10px",
    },
    loginBut: {
      width: "100%",
      backgroundColor: theme.palette.primary.main,
      fontSize: "x-large !important",
      textTransform: "capitalize !important",
      "&:hover": {
        opacity: theme.palette.action.hoverOpacity,
      },
    },
    paperBox: {
      width: "100%",
      padding: "20px",
      display: "flex",
      gap: "10px",
      flexDirection: "column",
    },
  };
});
function LoginContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from;
  const { setSession } = useSession();
  const { setSubscriptionError } = useSubscription();
  const { isTheme2 } = useColorTheme();
  const { Container, loginBox, imgBox, loginBut, paperBox } = useStyle();
  const { setsnackBarData } = useContext(SnackBarContext);
  const [showPassword, setshowPassword] = useState(false);
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const { setToken } = useContext(SignalRContext);
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const initialValues = {
    userName: "",
    password: "",
    Module: "CRM",
  };
  useFCM();

  useEffect(() => {
    if (queryParams.size > 0) {
      sessionStorage.setItem("access_token", queryParams.get("tokenNew"));
      sessionStorage.setItem("user", queryParams.get("Roles"));
      sessionStorage.setItem("LoginId", queryParams.get("LoginIdNew"));
      sessionStorage.setItem("IsAiEnabled", queryParams.get("IsAiEnabled"));
      sessionStorage.setItem("ChatUserId", queryParams.get("ChatUserId"));
      sessionStorage.setItem("isChat", queryParams.get("IsChat"));
      sessionStorage.setItem("LogoutDisable", true);
      sessionStorage.setItem("IsSuperAdmin", queryParams.get("IsSuperAdmin"));
    }
  }, [queryParams]);
  const { session } = useSession();
  const user = session?.user;
  const isSuperAdmin = session?.IsSuperAdmin;
  const isAdmin = session?.isAdmin;
  const businessType = session?.BusinessType;

  const handleRedirect = (roles, isSuperAdminCheck, currentBusinessType, isAdminCheck, forceRoleHome = false) => {
    if (isSuperAdminCheck) {
      navigate(forceRoleHome ? "/business" : from || "/business");
      return;
    }

    if (forceRoleHome && isAdminCheck) {
      navigate("/dashboard");
      return;
    }

    if (from && from !== "/") {
      const allRoutes = isSuperAdminCheck ? SuperAdminRoutes : AdminRoutes;
      const validFromRoute = allRoutes.find(route => route.path === from);

      // Only redirect to 'from' if it's a valid route and the user has permission
      const hasFromRole =
        !validFromRoute.roleName ||
        (Array.isArray(validFromRoute.roleName)
          ? validFromRoute.roleName.some((r) => roles?.includes(r))
          : roles?.includes(validFromRoute.roleName));

      if (validFromRoute && hasFromRole) {
        navigate(from);
        return;
      }
    }

    if (isAdminCheck) {
      navigate("/dashboard");
      return;
    }

    let baseData =
      isSuperAdminCheck === true
        ? SuperAdminSideBarData
        : currentBusinessType === "RealState"
        ? AdminSideBarData
        : GeneralSidebarData;

    let defaultRoute = "/";

    for (const item of baseData) {
      // Prioritize checking subitems first to ensure deep-linking to specific child roles (like WhatsApp)
      if (item.subitems && item.subitems.length > 0) {
        const validSubitem = item.subitems.find(sub => roles?.some(role => role === sub?.RoleName));
        if (validSubitem) {
          defaultRoute = validSubitem.path;
          break;
        }
      }

      // If no subitem matches, check if the parent matches
      if (roles?.some(role => role === item?.RoleName)) {
        defaultRoute = item.path;
        break;
      }
    }

    navigate(defaultRoute);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("access_token");

    if (token && user) {
      handleRedirect(user, isSuperAdmin, businessType, isAdmin, true);
    }
  }, [user, isSuperAdmin, isAdmin, businessType]);

  const emailRegex = /^[A-Za-z0-9.+_-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const ValidationSchema = Yup.object().shape({
    userName: Yup.string()
      .matches(emailRegex, "Please enter a valid email address")
      .required("Please Enter userName"),
    password: Yup.string().required("Please Enter password"),
  });
  const handleSubmit = async (values, resetForm, setSubmitting) => {
    const cleanValues = {
      ...values,
      userName: values.userName.trim(),
      password: values.password.trim(),
    };

    const response = await LoginApi(cleanValues);

    // Blocked subscription — show modal instead of generic error snackbar
    if (response?.data?.IsSubscriptionExpired === true) {
      setSubmitting(false);
      setShowExpiredModal(true);
      return;
    }

    if (response?.snackBarData?.type !== "success") {
      setsnackBarData(response.snackBarData);
    }

    if (response?.data?.IsSuccess) {
      // Keep submitting state true so the spinner continues to show during navigation

      setSession({
        ChatUserId: response.data?.ChatUserId || null,
        ChatBusinessId: response.data?.ChatBusinessId || null,

        user: response.data?.UserRoles || null,
        isChat: response.data?.IsChat ?? null,
        LoginId: response.data?.LoginId || null,
        IsAiEnabled: response.data?.IsAiEnabled || null,
        isAdmin: response.data?.IsAdmin ?? null,
        BusinessType: response.data?.BusinessType || null,
        BusinessId: response.data?.BusinessId || null,
        IsSuperAdmin: response.data?.IsSuperAdmin || null,
        Currency: response.data?.Currency || null,
      });
      if (response.data?.Currency) {
        sessionStorage.setItem("Currency", response.data.Currency);
      }
      sessionStorage.setItem("guide", response.data.IsGuide);
      setToken(response?.data?.Token);
      dispatch(fetchUserRoles(response.data.LoginId))
        .unwrap()
        .then(() => { })
        .catch(error => {
          setSubscriptionError(error);
        });
      handleRedirect(
        response.data?.UserRoles,
        response.data?.IsSuperAdmin,
        response.data?.BusinessType,
        response.data?.IsAdmin,
      );
    } else {
      setSubmitting(false);
    }
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      handleSubmit(values, resetForm, setSubmitting);
    },
  });
  return (
    <Box className={Container}>
      <form
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
        onSubmit={formik.handleSubmit}
      >
        <Box className={loginBox}>
          {!isTheme2 && (
            <Box className={imgBox}>
              <img style={{ width: "200px" }} src={logo} alt="logo" />
            </Box>
          )}
          <Paper elevation={3} sx={{ padding: "20px 10px" }}>
            <Box className={paperBox}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: theme => theme.palette.grey[800],
                }}
              >
                Welcome Back
              </Typography>
              <Box>
                <Typography variant="label">Email</Typography>
                <TextField
                  type={"email"}
                  id="userName"
                  size="small"
                  fullWidth
                  name="userName"
                  value={formik.values.userName}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/[^A-Za-z0-9.+_@-]/g, "");
                    formik.handleChange(e);
                  }}
                  error={Boolean(formik.errors.userName) && Boolean(formik.touched.userName)}
                  helperText={Boolean(formik.touched.userName) && Boolean(formik.errors.userName) ? formik.errors.userName : ""}
                />
              </Box>
              <Box>
                <Typography variant="label">Password</Typography>
                <FormControl fullWidth error={Boolean(formik.errors.password) && Boolean(formik.touched.password)}>
                  <OutlinedInput
                    type={showPassword ? "text" : "password"}
                    size="small"
                    id="password"
                    fullWidth
                    name="password"
                    onChange={formik.handleChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setshowPassword(!showPassword);
                          }}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  // error={Boolean(formik.errors.password) && Boolean(formik.touched.password)}
                  // helperText={Boolean(formik.errors.password) && formik.errors.password}
                  />
                  <FormHelperText>
                    {Boolean(formik.errors.password) && Boolean(formik.touched.password) ? formik.errors.password : ""}
                  </FormHelperText>
                </FormControl>

                <Typography
                  variant="small"
                  onClick={() => navigate("/forgotpassword")}
                  sx={{
                    color: theme => theme.palette.blue.main,
                    cursor: "pointer",
                    fontSize: "x-small",
                  }}
                >
                  Forgot Password?
                </Typography>
              </Box>
              {formik.isSubmitting ? (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <Button id="btnLogin" type="submit" sx={{ color: "white !important" }} className={loginBut}>
                  Login
                </Button>
              )}
              <Typography
                variant="caption"
                sx={{
                  textAlign: "center",
                  display: "block",
                  marginTop: "8px",
                  fontSize: "0.65rem",
                  color: "#6c757d",
                }}
              >
                By logging in, you agree to our{" "}
                <a
                  href="https://aiksol360.com/terms-conditions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "#5696e0" }}
                  onMouseEnter={e => (e.target.style.color = "#1987fc")}
                  onMouseLeave={e => (e.target.style.color = "#5696e0")}
                >
                  Terms & Conditions
                </a>{" "}
                and{" "}
                <a
                  href="https://aiksol360.com/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "#5696e0" }}
                  onMouseEnter={e => (e.target.style.color = "#1987fc")}
                  onMouseLeave={e => (e.target.style.color = "#5696e0")}
                >
                  Privacy Policy
                </a>
                .
              </Typography>
            </Box>
          </Paper>
        </Box>
        <div className="video-box">
          <div className="video-container">
            {isTheme2 ? (
              <img
                src={goldenBuildings}
                alt="Golden Buildings"
                className="video"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <video src={imbl} autoPlay loop muted className="video" />
            )}
          </div>
        </div>
      </form>

      {/* Blocked-subscription modal — shown when login API returns IsSubscriptionExpired=true.
          Mirrors the ERP login.js pattern (type="blocked"). */}
      {showExpiredModal && (
        <PaymentReminderModal
          open={showExpiredModal}
          onClose={() => setShowExpiredModal(false)}
          type="blocked"
        />
      )}
    </Box>
  );
}

export default LoginContent;
